function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import icSuccess from 'assets/svg/ic_success_V2.svg';
import { useTypedSelector } from '@profile/src/redux/utils';
import { ellipsisMiddle } from '@profile/src/utils/text';
import Button from '@profile/src/Components/Button';
import Modal from '@profile/src/Components/PopupModal_V2';
import { logCreatAccountFinish } from '@profile/src/utils/analytic';
import { useTestId } from '@wolffun/testable-id';

const ConnectWalletSuccessModal = ({
  onClose,
  isCreateAccount
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const account = useTypedSelector(state => {
    var _state$connectWallet$;

    return ((_state$connectWallet$ = state.connectWallet.accounts) === null || _state$connectWallet$ === void 0 ? void 0 : _state$connectWallet$[0]) || '';
  });
  React.useEffect(() => {
    if (isCreateAccount) logCreatAccountFinish();
  }, []);
  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close-button'), {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.img
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "awesome!"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "Wallet ", /*#__PURE__*/React.createElement("span", {
    className: styles.addr
  }, ellipsisMiddle(account)), "\xA0now linked to your game account! Login to get started."), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({}, generateTestIdProps('login-now'), {
    onClick: onClose,
    className: styles.btn,
    title: "Login now"
  }))));
};

export default ConnectWalletSuccessModal;